import api from '../../api/departmentRoutes.js';

const namespaced = true;
 
export const state = {
    departamentos:[]
}

const mutations = {
    MUTATION_SET_DEPARTMENTS(state, value){
        state.departamentos = value;
    },
}

const actions = {
    getDepartments(context){
        return new Promise((resolve, reject) => {
            api.getDepartments().then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_SET_DEPARTMENTS', resp.data);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al obtener indicadores'));
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
}

const getters = {
    getDepartamentos(state){
        return state.departamentos;
    },
}

export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}